import { Stack } from '@heathmont/moon-components';
import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';
import media from '~/client/shared/media';

const SharePanel = styled(Stack)`
  && {
    position: absolute;
    top: ${rem(52)};
    left: ${rem(-68)};
    display: flex;
    flex-direction: column;
    align-items: center;
    ${media.tabletMedium} {
      left: ${rem(-172)};
    }
    svg,
    img {
      cursor: pointer;
    }
  }
`;

export default SharePanel;
